import { Download, ExternalLink } from "lucide-react";
import { previewUrl, useDownloadDocument } from "../api/pdfApi";
import type { PdfDocument } from "../types";

/**
 * Podgląd pliku w ramce. Treść leci PRZEZ nasz backend (a nie adresem z magazynu),
 * więc przy każdym otwarciu uprawnienia sprawdzane są od nowa. Ramka nie dodaje
 * nagłówka z tokenem — stąd krótko żyjący bilet w adresie.
 */
export function DocumentPreview({
  document: doc,
  ticket,
}: {
  document: PdfDocument;
  ticket: string | undefined;
}) {
  const download = useDownloadDocument();

  if (!ticket) {
    return (
      <div className="flex h-full items-center justify-center text-xs text-[var(--color-text-muted)]">
        Przygotowuję podgląd…
      </div>
    );
  }
  const url = previewUrl(doc.id, ticket);
  const isImage = doc.kind === "image";

  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="flex items-center justify-between border-b border-[var(--color-border)] px-3 py-1.5">
        <span className="truncate font-mono text-[11px] text-[var(--color-text-secondary)]">
          {doc.name} · wersja {doc.version_number}
        </span>
        <span className="flex items-center gap-3">
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            className="section-label flex items-center gap-1 hover:text-[var(--color-primary)]"
          >
            <ExternalLink size={12} /> W nowej karcie
          </a>
          <button
            type="button"
            onClick={() => download.mutate(doc)}
            disabled={download.isPending}
            className="section-label flex items-center gap-1 hover:text-[var(--color-primary)] disabled:opacity-40"
          >
            <Download size={12} /> {download.isPending ? "Pobieram…" : "Pobierz"}
          </button>
        </span>
      </div>
      <div className="min-h-0 flex-1 bg-[var(--color-bg-overlay)]">
        {isImage ? (
          <div className="flex h-full items-center justify-center overflow-auto p-4">
            <img src={url} alt={doc.name} className="max-h-full max-w-full" />
          </div>
        ) : (
          <iframe title={`Podgląd ${doc.name}`} src={url} className="h-full w-full border-0" />
        )}
      </div>
    </div>
  );
}
